<script setup lang="ts">
import {computed} from 'vue';
import WorldCountries, { WorldCountryCode } from '@/config/world-countries-en';
import StfDropdown from '@/ui/dropdown/StfDropdown.vue';
import type { DropdownItem, DropdownOption } from '@/ui/dropdown/StfDropdown';
import useCountry from '@/composables/countryDependable';

defineProps<{
    modelValue: string
}>();

const emit = defineEmits(['update:modelValue']);
const country = useCountry();

const countriesOptions = computed(() => {
    let options: DropdownItem[] = Object.entries(WorldCountries).map(([code, name]) => ({
        value: code,
        label: name
    }));

    options.unshift({ type: 'search' });

    //add default country
    options.unshift({
        value: country.code,
        label: WorldCountries[country.code as unknown as WorldCountryCode]
    });

    return options;
})

</script>

<template>
    <StfDropdown 
        label="Country" 
        placeholder="Country" 
        required 
        :options="countriesOptions"
        :modelValue="modelValue"
        @update:modelValue="emit('update:modelValue', $event)"
    ></StfDropdown>
</template>

<style scoped>

</style>
